export default __webpack_public_path__ + "static/media/user_image_3.7ccecb10.jpg";